export default __webpack_public_path__ + "static/menu-tachibanaudon-min1-6f59aaaab257829068c9b6d49d259e5b.jpg";